import { useContext, useState } from "react";
import { TwoFALogin } from "features/auth/TwoFALogin";
import {
  LoginChallenge,
  LoginRequest,
  LoginResponse,
  OAuthUserRequest,
} from "@shared/types";
import NewIpLogin from "features/auth/NewIpLogin";
import LoginForm from "features/auth/LoginForm";
import { ExternalConnectAccountContext } from "@shared/features/configuration/ExternalConnectAccount.context.ts";
import { setExternalInviteLocalStorageLogin } from "features/configuration/common/utils.ts";

const LoginPage = () => {
  const [loginDetails, setLoginDetails] = useState<
    LoginRequest | OAuthUserRequest | undefined
  >();
  const [loginResponse, setLoginResponse] = useState<
    LoginResponse | undefined
  >();
  const [isBiometricLogin, setIsBiometricLogin] = useState<boolean>(false);
  const { isExternalConnectAccount, handleAuthCompleted } =
    useContext(ExternalConnectAccountContext) || {};

  const onFinalizedLogin = () => {
    if (isExternalConnectAccount) {
      handleAuthCompleted?.();
    } else {
      setExternalInviteLocalStorageLogin();
    }
  };

  if (loginDetails) {
    if (loginResponse?.challenge === LoginChallenge.TWO_FA) {
      return (
        <TwoFALogin
          loginDetails={loginDetails}
          isBiometricLogin={isBiometricLogin}
          onFinalizedLogin={onFinalizedLogin}
        />
      );
    } else if (loginResponse?.challenge === LoginChallenge.NEW_IP) {
      return (
        <NewIpLogin
          loginDetails={loginDetails}
          isBiometricLogin={isBiometricLogin}
          onFinalizedLogin={onFinalizedLogin}
        />
      );
    }
  }

  return (
    <LoginForm
      onSuccessfulLogin={(args: LoginRequest | OAuthUserRequest) =>
        setLoginDetails(args)
      }
      setIsBiometricLogin={setIsBiometricLogin}
      setLoginResponse={setLoginResponse}
      onFinalizedLogin={onFinalizedLogin}
    />
  );
};

export default LoginPage;
